import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { UploadsModel } from '../models/upload/uploads.model';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthGaurdService } from './auth-gaurd.service';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';

@Injectable({
  providedIn: 'root'
})

export class UploadsService {
  public uploadsModel = new UploadsModel();
  myTemplateSet = new Set<string>();
  private host = environment.apiUrl + "uploads/recordtemplate";
  public loggedinUser: string = '';
  opts = [];
  optsEmpEmp = [];

  constructor(private http: HttpClient,
    private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    this.loggedinUser = this.authGaurdService.loginUser();
  }

  public getTemplatesList(): Observable<UploadsModel[]> {
    return this.http.get<UploadsModel[]>(`${this.host}/gettemplateslist`);
  }

  public getRecordsList(recordname: string): Observable<UploadsModel[]> {
    return this.http.get<UploadsModel[]>(`${this.host}/getrecordslist` + '/' + recordname);
  }

  public deleteTemplate(id: number, recordname: string, recordtemplate: string): Observable<CustomHttpRespone> {
    return this.http.delete<CustomHttpRespone>(`${this.host}/deletetemplate/` + id + '/' + recordname + '/' + recordtemplate);
  }

  public getColumnsList(recordName: string): Observable<UploadsModel[]> {
    return this.http.get<UploadsModel[]>(`${this.host}/getcolumnslist` + '/' + recordName);
  }

  public getColumnsEditList(recordName: string): Observable<UploadsModel[]> {
    return this.http.get<UploadsModel[]>(`${this.host}/getcolumnseditlist` + '/' + recordName);
  }
  public saveTemplate(uploadsModel: UploadsModel[]): Observable<UploadsModel[]> {
    return this.http.post<UploadsModel[]>(`${this.host}/addtemplate`, uploadsModel);
  }

  public updateTemplate(uploadsModel: UploadsModel[]): Observable<UploadsModel[]> {
    return this.http.post<UploadsModel[]>(`${this.host}/updatetemplate`, uploadsModel);
  }

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}


